import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Machine is us",
  "description": "",
  "published": "2007-04-11T00:00:00.000Z",
  "redirect_from": ["/blog/the-machine-is-us/swizec/235"],
  "categories": "food for thought, intrigues, video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If this video doesn't make you think then you are a brainless moron incapable of human behaviours and have been completely assimilated. I now finally see the web for what it is, the Borg.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      